<template>
  <div id="Record">
    <Select
      v-model="state"
      @on-change="
        getData();
        pageNow = 1;
      "
      style="width: 200px; margin-bottom: 10px"
      placeholder="选择状态"
    >
      <Option v-for="item in types" :value="item.value" :key="item.value">{{
        item.label
      }}</Option>
    </Select>
    <Table
      style="font-size: 20px"
      border
      stripe
      :columns="columns1"
      :data="TemplateData"
    >
      <template slot-scope="{ row, index }" slot="state">
        <div v-if="row.state == 0">执行中</div>
        <div v-if="row.state == 1">已完成</div>
        <div v-if="row.state == 2">已暂停</div>
      </template>
      <template slot-scope="{ row, index }" slot="config">
        <Button
          v-if="row.state == 1 && row.failCount > 0"
          style="margin-left: 10px"
          @click="repeat(row)"
          >消息重发</Button
        >
      </template>
    </Table>
    <Modal
      v-model="configMessage"
      :title="configTitle"
      width="700px"
      @on-ok="updatedMessage"
    >
      <div class="config">
        <div class="title">模板</div>
        <Select @input="getStencil()" v-model="stencil" style="width: 200px">
          <Option v-for="item in cityList" :value="item.id" :key="item.id">{{
            item.title
          }}</Option>
        </Select>
      </div>

      <div class="config">
        <div :style="'color:' + stencilData.first.color" class="title">
          {{ stencilData.first.name }}
        </div>
        <Input
          :style="'color:' + stencilData.first.color"
          v-model="stencilData.first.value"
          :placeholder="stencilData.first.name"
        ></Input>
      </div>
      <div class="config" v-for="data in stencilData.keywords">
        <div :style="'color:' + data.color" class="title">{{ data.name }}</div>
        <Input
          :style="'color:' + data.color"
          v-model="data.value"
          :placeholder="data.name"
        ></Input>
      </div>
      <div class="config">
        <div :style="'color:' + stencilData.remark.color" class="title">
          {{ stencilData.remark.name }}
        </div>
        <Input
          :style="'color:' + stencilData.remark.color"
          v-model="stencilData.remark.value"
          :placeholder="stencilData.remark.name"
        ></Input>
      </div>
      <div class="config">
        <div class="title">并发任务数量</div>
        <Input
          type="number"
          v-model="stencilData.threads"
          placeholder="并发任务数量"
        ></Input>
      </div>
    </Modal>

    <Button @click="Add()" style="float: right; margin-top: 15px">新增</Button>
    <Page
      @on-change="pagingSuery"
      style="margin-top: 15px; float: left"
      :total="total"
    ></Page>
  </div>
</template>

<script>
import { api } from "../biz/api";
export default {
  name: "Record",
  data() {
    return {
      pageNow: 1,
      stencil: "",
      stencilData: { keywords: [{}], first: {}, remark: {}, threads:1 },
      cityList: [],
      state: null,
      configTitle: "",
      types: [
        {
          value: 0,
          label: "执行中",
        },
        {
          value: 1,
          label: "已完成",
        },
        {
          value: 2,
          label: "已暂停",
        },
      ],

      configMessage: false,
      total: 0,
      TemplateData: [],
      columns1: [
        {
          title: "标题",
          align: "center",
          key: "title",
        },
        {
          title: "预计群发总数",
          align: "center",
          key: "pushCount",
        },
        {
          title: "成功总数",
          align: "center",
          key: "succCount",
        },
        {
          title: "失败总数",
          align: "center",
          key: "failCount",
        },
        {
          title: "状态",
          align: "center",
          key: "state",
          slot: "state",
        },
        {
          title: "创建时间",
          align: "center",
          key: "createTime",
        },
        {
          title: "最后修改时间",
          align: "center",
          key: "modifyTime",
        },
        {
          title: "操作",
          key: "address",
          align: "center",
          slot: "config",
        },
      ],
    };
  },
  mounted: function () {
    this.getData();
  },
  activated: function () {},

  methods: {
    getStencil() {
      api.WtempGet(this.stencil).then((res) => {
        this.stencilData = res.body.data;
        this.stencilData.keywords = JSON.parse(this.stencilData.keywords);
        this.stencilData.first = JSON.parse(this.stencilData.first);
        this.stencilData.remark = JSON.parse(this.stencilData.remark);
        this.stencilData.threads = 1;
        this.$forceUpdate();
        console.log(this.stencilData);
      });
    },
    repeat(res) {
      api.ResendMsg(res.id).then((res) => {
        if (res.body.status == 1) {
          alert(res.body.message);
        }
        this.getData();
      });
    },
    getData() {
      api
        .WechatHistory({ pageNow: this.pageNow, state: this.state })
        .then((res) => {
          this.total = res.body.data.total;
          this.TemplateData = res.body.data.list;
        });
    },
    Add() {
      this.configTitle = "新增";
      this.configMessage = true;
      api.WtempList({ pageNow: this.pageNow, pageSize: 9999 }).then((res) => {
        this.cityList = res.body.data.list;
        this.stencil = this.cityList[0].id;
        this.getStencil();
      });
      this.stencilData = { keywords: [{}], first: {}, remark: {}, threads: 1 };
    },

    updatedMessage() {
      for (let i = 0; i < this.stencilData.keywords.length; i++) {
        this.stencilData.keywords[i].name = "keyword" + (i + 1);
      }
      this.stencilData.first.name = "first";
      this.stencilData.remark.name = "remark";
      this.stencilData.keywords.push(this.stencilData.first);
      this.stencilData.keywords.push(this.stencilData.remark);
      this.stencilData.keywords = JSON.stringify(this.stencilData.keywords);
      let data = {
        templateId: this.stencilData.id,
        threads: this.stencilData.threads,
        data: this.stencilData.keywords,
      };
      api.WechatPushMsg(data).then((res) => {
        this.getData();
      });
    },

    pagingSuery(pageNow) {
      this.pageNow = pageNow;
      this.getData();
    },
  },
};

// GetRewardTotal
</script>

<style scoped  >
#Record {
  height: 100%;
  overflow: hidden;
}
.config {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.title {
  float: left;
  width: 200px;
}
</style>